"use client";

import { useRef } from "react";
import { useMatch } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { useAppEvent } from "@/lib/events";

/**
 * Subscribes to the `approval-success` app event (fired by ApprovalActionsRow after
 * the user approves a draft and the POST succeeds) and surfaces a transient toast
 * with a contextual success message based on the action type.
 *
 * Mount once at the layout level (same pattern as PraetorRevisionToastBridge).
 */
export function ApprovalSuccessToastBridge() {
  const { t } = useTranslation();
  const match = useMatch("/:caseId/:threadId");
  const activeThreadId = match?.params.threadId ?? null;

  const activeThreadIdRef = useRef(activeThreadId);
  activeThreadIdRef.current = activeThreadId;

  useAppEvent("approval-success", (payload) => {
    const eventThreadId = payload?.threadId ?? null;
    if (eventThreadId !== null && eventThreadId !== activeThreadIdRef.current) {
      return;
    }

    if (payload.action === "save_revision") {
      toast.success(t("approval.success_revision", { name: payload.documentName ?? "" }));
    } else if (payload.action === "commit_version") {
      toast.success(t("approval.success_new_version", { name: payload.documentName ?? "" }));
    } else {
      toast.success(t("approval.success_generic"));
    }
  });

  return null;
}
